import React, { useState, useRef, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "../../authAxios";
import { Camera } from "react-camera-pro";
import photoImg from "../../Assets/Image.png";
import Logo from "../../Assets/Logo.png";
import { RxCross2 } from "react-icons/rx";
import Swal from "sweetalert2";
import PoweredBy from "../PoweredBy/PoweredBy";
import "./Form.css";

export default function Form({ onClose, refresh }) {
  const [openCamera, setopenCamera] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  const [employeList, setEmployeList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const cameraRef = useRef(null);

  useEffect(() => {
    const getEmps = () => {
      try {
        axios.get("/get-employees").then((response) => {
          if (response.data.status) {
            setEmployeList(response.data.data.results);
            console.log(response.data.data.results);
          }
          return;
        });
      } catch (error) {
        console.log(error);
      }
    };
    const getLocs = () => {
      try {
        axios.get("/get-locations").then((response) => {
          if (response.data.status) {
            setLocationList(response.data.data.results);
            console.log(response.data.data.results);
          }
          return;
        });
      } catch (error) {
        console.log(error);
      }
    };
    getEmps();
    getLocs();
  }, []);

  // const [showForm, setshowForm] = useState(open)

  const [formData, setFormData] = useState({
    visitorName: "",
    visitorContact: "",
    visitorEmail: "",
    hostId: "",
    officeId: "",
    reason: "",
  });

  const handlePhotoCapture = (dataUri) => {
    setImageSrc(dataUri);
  };
  const handleLocationChange = (event, newValue) => {
    const { name, id } = newValue;
    setFormData({ ...formData, officeId: id });
    console.log(newValue);
    console.log(event);
  };
  const handleEmployeChange = (event, newValue) => {
    const { name, id } = newValue;
    setFormData({ ...formData, hostId: id });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    if (name === "visitorContact" && value.length === 10) {
      fetchVisitorDetails(value);
    }
  };

  const fetchVisitorDetails = async (mobileNumber) => {
    try {
      const response = await axios.get(
        `/get-visitor-by-mobile/${mobileNumber}`
      );
      if (response.data.status && response.data.data.results.length > 0) {
        const visitor = response.data.data.results[0];
        setFormData((prevFormData) => ({
          ...prevFormData,
          visitorName: visitor.name || "",
          visitorEmail: visitor.email || "",
        }));
      } else {
        // Swal.fire({
        //   position: "center",
        //   icon: "info",
        //   title: "No visitor data found",
        //   showConfirmButton: false,
        //   timer: 1500,
        // });
      }
    } catch (error) {
      console.error("Error fetching visitor details:", error);
      // Swal.fire({
      //   position: "center",
      //   icon: "error",
      //   title: "Failed to fetch visitor details",
      //   showConfirmButton: false,
      //   timer: 1500,
      // });
    }
  };

  const handleSubmit = () => {
    // e.preventDefault();
    var objValues = Object.values(formData);

    console.log(formData);

    if (objValues.includes("")) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Fill input fields",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    if (imageSrc == "") {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Click Yours Image",
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }
    try {
      setFormSubmitted(true)
      axios
        .post("/new-visit", {
          visitor_name: formData.visitorName,
          visitor_email: formData.visitorEmail,
          visitor_phone_number: formData.visitorContact,
          visitor_image: imageSrc,
          employee_id: formData.hostId,
          reason: formData.reason,
          location_id: formData.officeId,
        })
        .then((response) => {
          if (response.data.status) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Visit applied successfully!",
              showConfirmButton: false,
              timer: 1500,
            });
            setFormSubmitted(false);
            onClose();
            {
              refresh && refresh();
            }
            // ();
            return;
          }
          Swal.fire({
            position: "center",
            icon: "error",
            title: response.data,
            showConfirmButton: false,
            timer: 1500,
          });
          setFormSubmitted(false);
        })
        .catch((err) => {
          Swal.fire({
            position: "center",
            icon: "error",
            title: err,
            showConfirmButton: false,
            timer: 1500,
          });
          setFormSubmitted(false);
        });
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: error,
        showConfirmButton: false,
        timer: 1500,
      });
      setFormSubmitted(false);
    }
  };

  const handleCaptureClick = () => {
    setopenCamera(!openCamera);
    console.log("currrrrr", cameraRef);
    if (cameraRef.current) {
      var url = cameraRef.current.takePhoto();
      setImageSrc(url);
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          width: "100%",
          backgroundColor: "#3c3c3c85",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: "100",
        }}
      >
        <div
          style={{
            border: "1px solid black",
            borderRadius: "5px",
            margin: "10px",
            width: "100%",
            maxWidth: "350px",
            padding: "10px 20px",
            backgroundColor: "white",
             position: "relative"
          }}
        >
            {/* <div style={{ position: "absolute", right: "0px", top: "30px" }}>
              <PoweredBy />
            </div> */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3 style={{ margin: "0px" }}>Create New Entry</h3>{" "}
            <RxCross2 onClick={onClose} size={20} />
          </div>

          {!openCamera && (
            <img
              src={imageSrc == "" ? photoImg : imageSrc}
              alt="Captured"
              style={{ width: "150px", height: "120px" }}
            />
          )}
          {openCamera && (
            <Camera
              onTakePhoto={handlePhotoCapture}
              ref={cameraRef}
              aspectRatio={10 / 4}
            />
          )}
          <br />
          {openCamera && <button onClick={handleCaptureClick}>Click</button>}
          {!openCamera && (
            <h5
              className="takePhotoBtn"
              style={{
                color: "gray",
                textDecoration: "underline",
                margin: "5px 0px 10px 0px",
              }}
              onClick={() => {
                setImageSrc("");
                setopenCamera(!openCamera);
              }}
            >
              Take Photo
            </h5>
          )}
          {/* <h5>Take Photo</h5> */}
          <TextField
            size="small"
            // fullWidth="100%"
            style={{ margin: "8px 0px", width: "100%" }}
            id="outlined-basic"
            label="Visitor Contact*"
            variant="outlined"
            name="visitorContact"
            value={formData.visitorContact}
            onChange={handleChange}
          />
          <br />
          <TextField
            size="small"
            // fullWidth="100"
            style={{ margin: "8px 0px", width: "100%" }}
            id="outlined-basic"
            label="Visitor Name*"
            variant="outlined"
            name="visitorName"
            value={formData.visitorName}
            onChange={handleChange}
          />
          <br />
          <TextField
            size="small"
            // fullWidth="100"
            style={{ margin: "8px 0px", width: "100%" }}
            id="outlined-basic"
            label="visitor Email*"
            variant="outlined"
            name="visitorEmail"
            value={formData.visitorEmail}
            onChange={handleChange}
          />
          <br />
          <Autocomplete
            size="small"
            id="hostName"
            autoHighlight
            style={{ margin: "8px 0px", width: "100%" }}
            onChange={handleEmployeChange}
            options={employeList?.map((option) => ({
              name: option?.name,
              id: option?.employee_id,
            }))}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                size="small"
                fullWidth="100"
                {...params}
                label="Host Name*"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-password", // disable autocomplete and autofill
                }}
              />
            )}
          />
          <Autocomplete
            size="small"
            id="office"
            autoHighlight
            options={locationList?.map((option) => ({
              id: option?.location_id,
              name: option?.location_name,
            }))}
            onChange={handleLocationChange}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                size="small"
                fullWidth="100"
                {...params}
                label="Office Location*"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-password", // disable autocomplete and autofill
                }}
              />
            )}
          />
          <br />
          <TextField
            size="small"
            // fullWidth="100"
            style={{ margin: "8px 0px", width: "100%" }}
            id="outlined-basic"
            label="Reason For Meet*"
            variant="outlined"
            name="reason"
            value={formData.reason}
            onChange={handleChange}
          />
          <br />
          <button
            style={{
              width: "100%",
              padding: "8px 16px",
              backgroundColor: "var(--primary-color)",
              boxShadow: "1px 1px 3px grey",
              borderRadius: "4px",
              color: "white",
            }}
            onClick={() => {
             
              handleSubmit();
            }}
            disabled={formSubmitted}
          >
            Create Entry
          </button>
        </div>
      </div>
    </div>
  );
}
